// Recovered compiled webpack factory 35737. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      generateSegmentsFromPatch: function () {
        return b;
      },
      handleExternalUrl: function () {
        return v;
      },
      navigateReducer: function () {
        return function e(t, r) {
          let { url: E, isExternalUrl: R, navigateType: P, shouldScroll: S, allowAliasing: O } = r,
            T = {},
            { hash: w } = E,
            j = (0, a.createHrefFromUrl)(E),
            x = "push" === P;
          if (
            ((0, m.prunePrefetchCache)(t.prefetchCache),
            (T.preserveCustomHistoryState = !1),
            (T.pendingPush = x),
            R)
          )
            return v(t, T, E.toString(), x);
          if (document.getElementById("__next-page-redirect")) return v(t, T, j, x);
          let A = (0, m.getOrCreatePrefetchCacheEntry)({
              url: E,
              nextUrl: t.nextUrl,
              tree: t.tree,
              prefetchCache: t.prefetchCache,
              allowAliasing: O,
            }),
            { treeAtTimeOfPrefetch: C, data: M } = A;
          return (
            d.prefetchQueue.bump(M),
            M.then(
              (d) => {
                let { flightData: m, canonicalUrl: R, postponed: P } = d,
                  O = Date.now(),
                  M = !1;
                if ((A.lastUsedTime || ((A.lastUsedTime = O), (M = !0)), A.aliased)) {
                  let n = new URL(E.href);
                  R && (n.pathname = R.pathname);
                  let a = (0, y.handleAliasedPrefetchEntry)(O, t, m, n, T);
                  return !1 === a ? e(t, { ...r, allowAliasing: !1 }) : a;
                }
                if ("string" == typeof m) return v(t, T, m, x);
                let N = R ? (0, a.createHrefFromUrl)(R) : j;
                if (w && t.canonicalUrl.split("#", 1)[0] === N.split("#", 1)[0])
                  return (
                    (T.onlyHashChange = !0),
                    (T.canonicalUrl = N),
                    (T.shouldScroll = S),
                    (T.hashFragment = w),
                    (T.scrollableSegments = []),
                    (0, c.handleMutable)(t, T)
                  );
                let k = t.tree,
                  I = t.cache,
                  L = [];
                for (let e of m) {
                  let {
                      pathToSegment: r,
                      seedData: a,
                      head: c,
                      isHeadPartial: d,
                      isRootRender: m,
                    } = e,
                    y = e.tree,
                    R = ["", ...r],
                    S = (0, i.applyRouterStatePatchToTree)(R, k, y, j);
                  if (
                    (null === S && (S = (0, i.applyRouterStatePatchToTree)(R, C, y, j)), null !== S)
                  ) {
                    if (a && m && P) {
                      let e = (0, _.startPPRNavigation)(O, I, k, y, a, c, d, !1, L);
                      if (null !== e) {
                        if (null === e.route) return v(t, T, j, x);
                        S = e.route;
                        let r = e.node;
                        null !== r && (T.cache = r);
                        let a = e.dynamicRequestTree;
                        if (null !== a) {
                          let r = (0, n.fetchServerResponse)(new URL(N, E.origin), {
                            flightRouterState: a,
                            nextUrl: t.nextUrl,
                          });
                          (0, _.listenForDynamicRequest)(e, r);
                        }
                      } else S = y;
                    } else {
                      if ((0, l.isNavigatingToNewRootLayout)(k, S)) return v(t, T, j, x);
                      let n = (0, p.createEmptyCacheNode)(),
                        a = !1;
                      for (let t of (A.status !== u.PrefetchCacheEntryStatus.stale || M
                        ? (a = (0, f.applyFlightData)(O, I, n, e, A))
                        : ((a = (function (e, t, r, n) {
                            let a = !1;
                            for (let o of ((e.rsc = t.rsc),
                            (e.prefetchRsc = t.prefetchRsc),
                            (e.loading = t.loading),
                            (e.parallelRoutes = new Map(t.parallelRoutes)),
                            b(n).map((e) => [...r, ...e])))
                              ((0, g.clearCacheNodeDataForSegmentPath)(e, t, o), (a = !0));
                            return a;
                          })(n, I, r, y)),
                          (A.lastUsedTime = O)),
                      (0, s.shouldHardNavigate)(R, k)
                        ? ((n.rsc = I.rsc),
                          (n.prefetchRsc = I.prefetchRsc),
                          (0, o.invalidateCacheBelowFlightSegmentPath)(n, I, r),
                          (T.cache = n))
                        : a && ((T.cache = n), (I = n)),
                      b(y))) {
                        let e = [...r, ...t];
                        e[e.length - 1] !== h.DEFAULT_SEGMENT_KEY && L.push(e);
                      }
                    }
                    k = S;
                  }
                }
                return (
                  (T.patchedTree = k),
                  (T.canonicalUrl = N),
                  (T.scrollableSegments = L),
                  (T.hashFragment = w),
                  (T.shouldScroll = S),
                  (0, c.handleMutable)(t, T)
                );
              },
              () => t,
            )
          );
        };
      },
    }));
  let n = r(32753),
    a = r(29658),
    o = r(75597),
    i = r(60895),
    s = r(58130),
    l = r(44707),
    u = r(86871),
    c = r(11126),
    f = r(77609),
    d = r(43933),
    p = r(17297),
    h = r(65360),
    _ = r(87317),
    m = r(83571),
    g = r(1281),
    y = r(21854);
  function v(e, t, r, n) {
    return (
      (t.mpaNavigation = !0),
      (t.canonicalUrl = r),
      (t.pendingPush = n),
      (t.scrollableSegments = void 0),
      (0, c.handleMutable)(e, t)
    );
  }
  function b(e) {
    let t = [],
      [r, n] = e;
    if (0 === Object.keys(n).length) return [[r]];
    for (let [e, a] of Object.entries(n))
      for (let n of b(a)) "" === r ? t.push([e, ...n]) : t.push([r, e, ...n]);
    return t;
  }
  (r(66048),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
